export const JWTStatuses = {
	EXPIRED: 1, // can call the refresh token api to exchange for new token. The expired is valid for 14 days.
	INVALID: 2,
	MISSING: 3,
};